/**
 * Minimal global footer rendered at the bottom of every authenticated page.
 * Exposes the legal pages required for GDPR / B2B compliance, plus support.
 */
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 pt-6 border-t border-border text-xs text-muted-foreground"
      data-testid="app-footer"
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-3 flex-wrap">
            <span>© {year} Veridex One.</span>
            <span className="hidden sm:inline opacity-40">·</span>
            <span>Trust infrastructure for global carbon compliance.</span>
          </div>
          <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground/80 font-medium">
            Reduce CBAM Risk · Increase Audit Confidence
          </span>
        </div>
        <nav className="flex items-center gap-4 flex-wrap" aria-label="Legal">
          <Link to="/legal/terms" className="hover:text-primary transition-colors" data-testid="footer-link-terms">
            Terms
          </Link>
          <Link to="/legal/privacy" className="hover:text-primary transition-colors" data-testid="footer-link-privacy">
            Privacy
          </Link>
          <Link to="/legal/dpa" className="hover:text-primary transition-colors" data-testid="footer-link-dpa">
            DPA
          </Link>
          <Link to="/legal/cookies" className="hover:text-primary transition-colors" data-testid="footer-link-cookies">
            Cookie Policy
          </Link>
          <Link to="/contact" className="hover:text-primary transition-colors" data-testid="footer-link-contact">
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
